export default function(instance) {
  return {
    getAllIndications() {
      return instance.get("/api/indications/");
    },
    getInvoices(data) {
      Object.keys(data).forEach(
        k => !data[k] && data[k] !== undefined && delete data[k]
      );

      return instance.get("/api/invoices/admin/", { params: data });
    },

    getInvoice(idInvoice) {
      return instance.get(`/api/invoices/admin/${idInvoice}/`);
    },
    deleteInvoice(idInvoice) {
      return instance.delete(`/api/invoices/admin/${idInvoice}/`);
    },

    uploadFile(data) {
      let formData = new FormData();
      formData.append("file", data.fileExcel);

      return instance.post(`/api/invoices/load_file/`, formData, {
        headers: {
          "Content-Type": "multipart/form-data"
        }
      });
    },

    deleteInvoice(idInvoice) {
      return instance.delete(`/api/invoices/${idInvoice}/`);
    }
  };
}
